// Freshness threshold for live data.
// BSR firmware pushes every 30s; demo.py pushes every 5s.
// 2 minutes = ~4× the slowest expected cadence — anything older is stale.
export const STALE_THRESHOLD_MS = 2 * 60 * 1000;

// Coerce a Firestore timestamp / number / Date into ms, or null if unknown.
export const tsMs = (v) => {
  if (v == null) return null;
  if (typeof v === 'number') return v;
  if (v?.toMillis) return v.toMillis();
  if (v instanceof Date) return v.getTime();
  if (typeof v === 'string') {
    const n = Date.parse(v);
    return isNaN(n) ? null : n;
  }
  return null;
};

// True when we have no timestamp at all OR the latest write is older than threshold.
export const isStale = (timestamp, now = Date.now()) => {
  const ms = tsMs(timestamp);
  if (ms == null) return true;
  return now - ms > STALE_THRESHOLD_MS;
};

// Human-readable "5m ago" / "2h ago" / "—"
export const ageLabel = (timestamp, now = Date.now()) => {
  const ms = tsMs(timestamp);
  if (ms == null) return '—';
  const diff = now - ms;
  if (diff < 60000) return `${Math.max(1, Math.floor(diff / 1000))}s ago`;
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
  return `${Math.floor(diff / 86400000)}d ago`;
};
